import { ModalBtnProps } from '@trackman/web-shared-components';
import { BlockingModal } from 'components/BlockingModal/BlockingModal';
import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  padding: 24px 32px;

  color: var(--grayscale-text-element, #414141);
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  line-height: 21px;

  display: flex;
  flex-direction: column;
  gap: 25px;
`;

interface EndGameDialogProps {
  onResumeGame: () => void;
  onEndGame: () => void;
  onClose: () => void;
  open: boolean;
  isAutoTagEnabled: boolean;
}

export const EndGameDialog: React.FC<EndGameDialogProps> = (props) => {
  const { onResumeGame, onEndGame, onClose, open, isAutoTagEnabled } = props;

  const confirmBtn: ModalBtnProps = {
    label: 'End game',
    onClick: onEndGame,
    width: '121px',
  };

  const cancelBtn: ModalBtnProps = {
    label: 'Cancel',
    onClick: onClose,
    width: '107px',

    style: {
      backgroundColor: '#F5F5F5',
      color: '#414141',
    },
  };

  const getContent = () => {
    if (isAutoTagEnabled) {
      return <>This game is set up to be tagged automatically. Once ended, a game cannot be resumed.</>;
    }

    return (
      <>
        <div>
          <b>If your session was interrupted</b>, it’s best to resume the game to avoid creating multiple sessions for the same game.
        </div>
        <div>
          <b>To access the game schedule or tag a different game</b>, continue with ending this session. Once ended, a game cannot be
          resumed.
        </div>
      </>
    );
  };

  return (
    <BlockingModal
      title='End this game?'
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='xs'
      confirmBtn={confirmBtn}
      cancelBtn={cancelBtn}
    >
      <Content>{getContent()}</Content>
    </BlockingModal>
  );
};
